import qs from 'qs'
import { Auth } from '@loca/mfe-vue3'

export function checkLogin() {
  const search = window.location.search
  const query = qs.parse(search, { ignoreQueryPrefix: true })
  const token = (query.token instanceof Array ? query.token[0] : query.token) as string

  if (token) {
    Auth.setTokens({
      access_token: token,
      refresh_token: token
    })
  }
  return Promise.resolve()
}
